import React, { useState } from 'react';
import GenericDocumentTable from './GenericDocumentTable';
import GenericDocumentTableHeader from './GenericDocumentTableHeader';
import GenericDocumentTableRowHeader from './GenericDocumentTableRowHeader';
import GenericDocumentTableBody from './GenericDocumentTableBody';
import GenericDocumentTableRow from './GenericDocumentTableRow';
import GenericDocumentTableRowData from './GenericDocumentTableRowData';
import { PrintOut } from '../pages/reports/PrintOut';
import { Image } from 'primereact/image';
import { fixBase64Mime, helper } from './utils/helper';
import { PrimeIcons } from 'primereact/api';
import { confirmPopup } from 'primereact/confirmpopup';
import { Button } from 'primereact/button';
import { InputTextarea } from 'primereact/inputtextarea';
import { Divider } from 'primereact/divider';

export default function ({ header = null, error = "", isGenericView = false, documents, setDocuments = () => { }, onclickPreview, showAction = false }) {

    var [showPdf, setShowPdf] = useState(false);
    var [pdf, setPdf] = useState(null);
    const imageFormats = [
        "jpeg",
        "jpg",
        "png",
        "gif",
        "bmp",
        "tiff",
        "tif",
        "webp",
        "svg",
        "ico",
        "apng"
    ];



    function renderDocument(row) {
        if (row?.jump?.length > 3) {
            return row?.jump
        }
        if (!row.binaryData.includes("data")) {
            return `data:image/png;base64,${row.binaryData}`
        }
        if (!row.binaryData.startsWith("data:image/")) {
            return row.binaryData
        }
        return fixBase64Mime(row.binaryData)

    }

    var Tag = isGenericView ? Divider : "div"

    return (
        <>
            {pdf !== null && <PrintOut isReport={false} base64={pdf} setBase64={setPdf} showDialog={showPdf} setShowDialog={setShowPdf} />}

            <GenericDocumentTable header={<>
                <Tag className={isGenericView ? 'p-datatable-header-custom' : 'p-datatable-header-custom2'} style={{ background: isGenericView ? "" : "#f8f9fa" }}><h5 style={{ margin: 0 }} className='text-black'>{header}</h5> </Tag>
                {error !== "" && <div className='w-full px-3 py-1' style={{ "background": "#fafafa" }}>{error}</div>}
            </>}>
                <GenericDocumentTableHeader>
                    {documents.length !== 0 && (
                        <GenericDocumentTableRowHeader width="20px">
                        </GenericDocumentTableRowHeader>)}

                    <GenericDocumentTableRowHeader width="200px">
                        Document Type
                    </GenericDocumentTableRowHeader>

                    {!showAction && <GenericDocumentTableRowHeader width="20px">
                        Version
                    </GenericDocumentTableRowHeader>}
                    <GenericDocumentTableRowHeader>
                        Preview
                    </GenericDocumentTableRowHeader>

                    {showAction && (<GenericDocumentTableRowHeader>
                        Action
                    </GenericDocumentTableRowHeader>)}
                </GenericDocumentTableHeader>
                <GenericDocumentTableBody>
                    {
                        documents.map((row, key) => <React.Fragment key={key}>
                            <GenericDocumentTableRow>
                                <GenericDocumentTableRowData spanRow={2}>
                                    {key + 1}
                                </GenericDocumentTableRowData>
                                <GenericDocumentTableRowData>
                                    {row.binaryType}
                                </GenericDocumentTableRowData>
                                {!showAction && <GenericDocumentTableRowData>
                                    {row.version}
                                </GenericDocumentTableRowData>}
                                <GenericDocumentTableRowData>
                                    <>
                                        {(row?.jump?.length > 3 || helper.checkBase64Type(row.binaryData) === "img" || imageFormats.includes(row?.ext)) && (
                                            <Image preview width="50px" src={renderDocument(row)} />
                                        )}
                                        {(helper.checkBase64Type(row.binaryData) === "pdf" || row?.ext === "pdf") && (
                                            <span
                                                onClick={() => {
                                                    setPdf(`${row.binaryData}`);
                                                    setShowPdf(true);
                                                }}
                                                style={{ cursor: "pointer", display: "inline-block", width: "100px", objectFit: "cover" }}
                                            >
                                                <i className={PrimeIcons.FILE_PDF} style={{ fontSize: "16px", color: "red" }}></i> PDF
                                            </span>
                                        )}
                                    </>
                                </GenericDocumentTableRowData>
                                {showAction && (<GenericDocumentTableRowData>
                                    {showAction && (<Button
                                        style={{
                                            textAlign: "center",
                                            width: "30px",
                                            height: "30px"
                                        }}
                                        icon={"pi pi-trash"}
                                        className="p-button-danger p-button-rounded"
                                        onClick={(e) => {
                                            e.preventDefault()
                                            e.stopPropagation()
                                            confirmPopup({
                                                target: e.currentTarget,
                                                message: "Are you sure you want to proceed?",
                                                icon: "pi pi-exclamation-triangle",
                                                defaultFocus: "accept",
                                                accept: () => {
                                                    try {
                                                        e?.preventDefault()
                                                        e?.stopPropagation()
                                                    } catch (error) {

                                                    }
                                                    var doc = documents.filter((_, index) => index !== key);
                                                    setDocuments(doc);
                                                },
                                                reject: () => {
                                                    try {
                                                        e?.preventDefault()
                                                        e?.stopPropagation()
                                                    } catch (error) {

                                                    }
                                                }
                                            });
                                        }}
                                    />)}
                                </GenericDocumentTableRowData>)}

                            </GenericDocumentTableRow>
                            <GenericDocumentTableRow>
                                <GenericDocumentTableRowData>
                                    Description
                                </GenericDocumentTableRowData>
                                <GenericDocumentTableRowData span="5">
                                    {showAction ? <InputTextarea style={{ width: "100%" }} value={documents[key].description} onChange={(e) => {
                                        documents[key].description = e.target.value;
                                        setDocuments([...documents]);
                                    }} rows={3} cols={30} /> : row.description}
                                </GenericDocumentTableRowData>
                            </GenericDocumentTableRow>
                        </React.Fragment>)
                    }


                    {documents.length === 0 && (<tr className="p-datatable-emptymessage" role="row" data-pc-section="emptymessage">
                        <td
                            colSpan={4}
                            role="cell"
                            data-pc-name="datatable"
                            data-pc-section="bodycell"
                        >
                            No results found
                        </td>
                    </tr>
                    )}


                </GenericDocumentTableBody>
            </GenericDocumentTable>
        </>
    );
}
